module.exports = __webpack_public_path__ + "e4913cfb6d08eceea3bdf6fe5804146a.png";